import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {PhoneService} from "./phone.service";
import {ActivatedRoute, Router} from "@angular/router";
import {isUndefined} from "util";
import {FlashMessagesService} from "angular2-flash-messages";
import {OrganizationService} from "../_service/organization.service";
import {HttpService} from "../_service/http.service";
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'app-phone',
  templateUrl: './phone.component.html',
  styleUrls: ['./phone.component.css'],
  providers: [PhoneService]
})
export class PhoneComponent implements OnInit {

  @Output()
  onCodeCheck = new EventEmitter();
  @Output()
  onPhoneUniqueFail = new EventEmitter();
  @Input()
  linkToGoAfterCodeCheck: string;
  @Input()
  phone: string;
  @Input()
  isNeedToConfirmBySms: string;
  @Input()
  isNeedToEnablePhoneInput = true;
  @Input()
  isNeedToEnableCheckPhoneUnique = true;
  @Input()
  isPhoneNeedToBeUnique = true;

  model: any = {
    numberPrefix: '+7'
  };
  receivingSMS = false;
  public isNewCodeRequired = false;
  errorMessage: string;
  isNumberConfirmed = false;
  isCheckingCode = false;
  isResendingCode = false;

  constructor(private phoneService: PhoneService, private router: Router,
              private flashMessagesService: FlashMessagesService,
              private httpService: HttpService,
              private route: ActivatedRoute, private orgService: OrganizationService) {
    this.onCodeCheck = new EventEmitter();
  }

  ngOnInit() {
    console.log("in phone component ", this.phone);

    if (!isUndefined(this.phone)) {
      this.model.phoneNumber = this.phone;
      // this.sendCode();
    }
  }

  confirmNumber() {
    // this.isNumberConfirmed = PhoneService.isPhoneNumberCorrect(this.model.phoneNumber);
    if (!PhoneService.isPhoneNumberCorrect(this.model.phoneNumber)) {
      this.flashMessagesService.show("Номер телефона введен в неверном формате",
        {cssClass: 'alert alert-danger danger-font small', timeout: 5000});
    } else {
      if (this.isNeedToEnableCheckPhoneUnique) {
        this.checkIsPhoneUnique(this.model.phoneNumber).then((isPhoneUnique: boolean) => {
          this.isNumberConfirmed = isPhoneUnique === this.isPhoneNeedToBeUnique;
          if (this.isNumberConfirmed) {
            if (this.isNeedToConfirmBySms) {
              this.sendCode();
            } else {
              this.onCodeCheck.emit({isCodeCorrect: true, phone: this.model.phoneNumber});
            }
          } else {
            this.onPhoneUniqueFail.emit(true);

            if (this.isPhoneNeedToBeUnique) {
              this.flashMessagesService.show("Номер телефона уже зарегистрирован",
                {cssClass: 'alert alert-danger danger-font small', timeout: 5000});
            } else {
              this.flashMessagesService.show("Номер телефона не найден",
                {cssClass: 'alert alert-danger danger-font small', timeout: 5000});
            }
          }
          return this.isNumberConfirmed;
        });
      } else {
        this.isNumberConfirmed = true;
        if (this.isNeedToConfirmBySms) {
          this.sendCode();
        } else {
          this.onCodeCheck.emit({isCodeCorrect: true, phone: this.model.phoneNumber});
        }
      }
    }

    // if (this.isNumberConfirmed) {
    //   f.controls['email'].setErrors(null);
    // } else {
    //   f.controls['email'].setErrors({'incorrect': true});
    // }
    return this.isNumberConfirmed;
  }

  checkIsPhoneUnique(phone: string): Promise<boolean> {

    const sb = [];
    sb.push('rest/' + localStorage.getItem('organizationAlias') + '/isPhoneUnique');
    sb.push('?');
    sb.push('&phoneNumber=');
    sb.push(encodeURIComponent(this.model.numberPrefix + phone));

    return this.httpService.getData(sb.join(''))
      .then((data) => {
        console.log("Registration: ", data);
        const isTrueData: boolean = data;
        // this.isPhoneUnique = isPhoneUnique;

        // if (!isTrueData) {
        //   this.onPhoneUniqueFail.emit(true);
        //   this.flashMessagesService.show("Пользователь с таким номером уже существует! " +
        //     "Вы можете попробовать восстановить пароль",
        //     {cssClass: 'alert alert-danger danger-font small', timeout: 5000});
        // }
        return isTrueData;
      }, error => {

        console.log("isPhoneUnique: error", error);
        this.flashMessagesService.show(JSON.parse(error._body).errorTitle,
          {cssClass: 'alert alert-danger danger-font small', timeout: 5000});
        return false;
      });
  }

  sendCode() {

    if (!this.isNeedToConfirmBySms) {
      console.log("No need to confirm by sms");
      return;
    }

    this.phoneService.sendConfirmationCode(this.model.numberPrefix + this.model.phoneNumber, this.isPhoneNeedToBeUnique)
      .then((data) => {
        if (!isUndefined(this.phone)) {
          this.flashMessagesService.show("На введенный Вами номер телефона отправлен код " +
            "подтверждения", {cssClass: 'popup-message flashfade alert-success', timeout: 5000});
        }
        this.receivingSMS = true;
        this.isNewCodeRequired = false;

      }, (error) => {
        this.isNewCodeRequired = JSON.parse(error._body).newCodeRequired;
        this.receivingSMS = JSON.parse(error._body).receivingSMS;
        this.flashMessagesService.show(JSON.parse(error._body).message,
          {cssClass: 'alert alert-danger danger-font small', timeout: 5000});
      });
  }

  checkCode() {

    this.isCheckingCode = true;
    this.phoneService.checkConfirmationCode(this.model.smsCode, this.model.numberPrefix + this.model.phoneNumber)
      .then((data) => {
        // Код подтверждения верный
        const result = {isCodeCorrect: true, phone: this.model.phoneNumber};
        this.onCodeCheck.emit(result);

        if (!isUndefined(this.linkToGoAfterCodeCheck)) {
          this.router.navigate(["../" + this.linkToGoAfterCodeCheck], {relativeTo: this.route});
        }
      }, (error) => {
        const result = {isCodeCorrect: false, phone: null};
        this.onCodeCheck.emit(result);
        this.isNewCodeRequired = JSON.parse(error._body).newCodeRequired;

        this.flashMessagesService.show(JSON.parse(error._body).message,
          {cssClass: 'alert alert-danger danger-font small', timeout: 5000});
      });

    (function (context) {
      setTimeout(() => {
        context.toggleCheckingCode(false);
      }, 1000);
    })(this);
  }

  toggleCheckingCode(value: boolean) {
    this.isCheckingCode = value;
  }

  toggleResendingCode(value: boolean) {
    this.isResendingCode = value;
  }

  async resendCode() {

    this.isResendingCode = true;
    await this.phoneService.resendConfirmationCode(this.model.numberPrefix + this.model.phoneNumber)
      .then((data) => {
      }, (error) => {
        this.isNewCodeRequired = JSON.parse(error._body).newCodeRequired;

        this.flashMessagesService.show(JSON.parse(error._body).message,
          {cssClass: 'popup-message flashfade alert-danger', timeout: 5000});
      });
    (function (context) {
      setTimeout(() => {
        context.toggleResendingCode(false);
      }, 1000);
    })(this);
  }
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/phone/phone.component.ts